export default [
  /**
   *  KERJASAMA
   */
  {
    path: "/dosen/kerjasama",
    name: "dosen-kerjasama",
    component: () => import("../../views/dosen/kerjasama/Kerjasama.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Kerjasama", active: true },
      ],
      pageTitle: "Kerjasama",
    },
  },
  {
    path: "/dosen/kerjasama/moa",
    name: "dosen-kerjasama-moa",
    component: () => import("../../views/dosen/kerjasama/moa/Moa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Kerjasama", url: "/dosen/kerjasama" },
        { title: "MoA", active: true },
      ],
      pageTitle: "Moa",
    },
  },
  {
    path: "/dosen/kerjasama/tambah-moa",
    name: "dosen-kerjasama-tambah-moa",
    component: () => import("../../views/dosen/kerjasama/moa/TambahMoa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Kerjasama", url: "/dosen/kerjasama" },
        { title: "MoA", url: "/dosen/kerjasama/moa" },
        { title: "Tambah MoA", active: true },
      ],
      pageTitle: "Tambah Moa",
    },
  },
  {
    path: "/dosen/kerjasama/moa/pihak-terkait/:moaId",
    name: "dosen-kerjasama-moa-pihak-terkait",
    component: () =>
      import("../../views/dosen/kerjasama/moa/MoaPihakTerkait.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Kerjasama", url: "/dosen/kerjasama" },
        { title: "MoA", url: "/dosen/kerjasama/moa" },
        { title: " Pihak Terkait", active: true },
      ],
      pageTitle: "Pihak Terkait",
    },
  },
  {
    path: "/dosen/kerjasama/moa/:moaId/dokumen",
    name: "dosen-kerjasama-moa-dokumen",
    component: () =>
      import("../../views/dosen/kerjasama/moa/TambahDokumenPendukung.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Kerjasama", url: "/dosen/kerjasama" },
        { title: "MoA", url: "/dosen/kerjasama/moa" },
        { title: "Dokumen Pendukung", active: true },
      ],
      pageTitle: "Dokumen Pendukung",
    },
  },
  {
    path: "/dosen/kerjasama/ia",
    name: "dosen-kerjasama-ia",
    component: () => import("../../views/dosen/kerjasama/ia/Ia.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Kerjasama", url: "/dosen/kerjasama" },
        { title: "IA", active: true },
      ],
      pageTitle: "IA",
    },
  },
  {
    path: "/dosen/kerjasama/tambah-ia",
    name: "dosen-kerjasama-tambah-ia",
    component: () => import("../../views/dosen/kerjasama/ia/TambahIa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Kerjasama", url: "/dosen/kerjasama" },
        { title: "IA", url: "/dosen/kerjasama/ia" },
        { title: "Tambah IA", active: true },
      ],
      pageTitle: "Tambah IA",
    },
  },
  {
    path: "/dosen/kerjasama/ia/bentuk-kegiatan/:iaId",
    name: "dosen-kerjasama-ia-bentuk-kegiatan",
    component: () =>
      import("../../views/dosen/kerjasama/ia/BentukKegiatan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Kerjasama", url: "/dosen/kerjasama" },
        { title: "IA", url: "/dosen/kerjasama/ia" },
        { title: "Bentuk Kegiatan", active: true },
      ],
      pageTitle: "Bentuk Kegiatan",
    },
  },

  {
    path: "/dosen/kerjasama/ia/pihak-terkait/:iaId",
    name: "dosen-kerjasama-ia-pihak-terkait",
    component: () =>
      import("../../views/dosen/kerjasama/ia/IaPihakTerkait.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Kerjasama", url: "/dosen/kerjasama" },
        { title: "IA", url: "/dosen/kerjasama/ia" },
        { title: "Pihak Terkait", active: true },
      ],
      pageTitle: "Pihak Terkait",
    },
  },
  {
    path: "/dosen/kerjasama/ia/:iaId/dokumen",
    name: "dosen-kerjasama-ia-dokumen",
    component: () =>
      import("../../views/dosen/kerjasama/ia/TambahDokumenPendukung.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Kerjasama", url: "/dosen/kerjasama" },
        { title: "IA", url: "/dosen/kerjasama/ia" },
        { title: "Dokumen Pendukung", active: true },
      ],
      pageTitle: "Dokumen Pendukung",
    },
  },
  /**
   *  NILAI MAHASISWA
   */
  {
    path: "/dosen/nilai-mahasiswa",
    name: "dosen-nilai-mahasiswa",
    component: () => import("../../views/dosen/nilai/NilaiMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Nilai Mahasiswa", active: true },
      ],
      pageTitle: "Nilai Mahasiswa",
    },
  },
  {
    path: "/dosen/input-nilai-mahasiswa/:urlEncoded",
    name: "dosen-input-nilai-mahasiswa",
    component: () => import("../../views/dosen/nilai/InputNilaiMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Input Nilai Mahasiswa", active: true },
      ],
      pageTitle: "Input Nilai Mahasiswa",
    },
  },

  {
    path: "/dosen/input-nilai-keseluruhan/:urlEncoded",
    name: "dosen-input-nilai-keseluruhan",
    component: () =>
      import("../../views/dosen/nilai/InputNilaiKeseluruhan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Input Nilai Keseluruhan", active: true },
      ],
      pageTitle: "Input Nilai Keseluruhan",
    },
  },

  //  Dosen > Report Nilai Mahasiswa

  {
    path: "/dosen/report-nilai-mahasiswa/:urlEncoded",
    name: "dosen-report-nilai-mahasiswa",
    component: () => import("../../views/dosen/nilai/ReportNilaiMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Report Nilai Mahasiswa", active: true },
      ],
      pageTitle: "Report Nilai Mahasiswa",
    },
  },
  // Dosen > Report Nilai Keseluruhan

  {
    path: "/dosen/report-nilai-keseluruhan/:urlEncoded",
    name: "dosen-report-nilai-keseluruhan",
    component: () =>
      import("../../views/dosen/nilai/ReportNilaiKeseluruhan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Report Nilai Keseluruhan", active: true },
      ],
      pageTitle: "Report Nilai Keseluruhan",
    },
  },

  /**
   *  KRS & PERWALIAN
   */

  {
    path: "/dosen/krs-perwalian",
    name: "dosen-krs",
    component: () => import("../../views/dosen/krs-perwalian/DosenKrs.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },

        { title: "Dosen", url: "/submenu/dosen" },
        { title: "KRS & Perwalian", active: true },
      ],
      pageTitle: "KRS & Perwalian",
    },
  },

  {
    path: "/dosen/dosen-validasi-ijazah",
    name: "dosen-validasi-ijazah",
    component: () =>
      import("../../views/dosen/validasi/DosenValidasiIjazah.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },

        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Validasi Ijazah Mahasiswa Perwalian", active: true },
      ],
      pageTitle: "Validasi Ijazah Mahasiswa Perwalian",
    },
  },

  {
    path: "/dosen/krs-perwalian/detail-krs/:mahasiswaId",
    name: "detail-krs",
    component: () => import("../../views/dosen//krs-perwalian/DetailKrs.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "KRS & Perwalian", url: "/dosen/krs-perwalian" },
        { title: "Detail KRS", active: true },
      ],
      pageTitle: "Detail KRS",
    },
  },

  {
    path: "/dosen/krs-perwalian/nilai-mahasiswa/:mahasiswaId",
    name: "dosen-wali-nilai-mahasiswa",
    component: () =>
      import("../../views/dosen/krs-perwalian/NilaiMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "KRS & Perwalian", url: "/dosen/krs-perwalian" },
        { title: "Nilai Mahasiswa", active: true },
      ],
      pageTitle: "Nilai Mahasiswa",
    },
  },

  {
    path: "/dosen/perwalian/:mahasiswaId",
    name: "dosen-perwalian",
    component: () => import("../../views/dosen/krs-perwalian/DosenWali.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },

        { title: "Dosen", url: "/submenu/dosen" },
        { title: "KRS & Perwalian", url: "/dosen/krs-perwalian" },
        { title: "Perwalian", active: true },
      ],
      pageTitle: "Perwalian",
    },
  },

  {
    path: "/dosen/tambah-perwalian/:mahasiswaId",
    name: "tambah-perwalian",
    component: () =>
      import("../../views/dosen/krs-perwalian/TambahPerwalian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "KRS & Perwalian", url: "/dosen/krs-perwalian" },
        { title: "Tambah Perwalian", active: true },
      ],
      pageTitle: "Tambah Perwalian",
    },
  },
  {
    path: "/dosen/krs-perwalian/pembayaran/:mahasiswaId",
    name: "dosen-perwalian-payment",
    component: () => import("../../views/korprodi/mahasiswa/CekPembayaran.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "KRS & Perwalian", url: "/dosen/krs-perwalian" },
        { title: "Payment", active: true },
      ],
      pageTitle: "Payment",
    },
  },

  /**
   *  ADMINISTRASI
   */
  {
    path: "/dosen/administrasi",
    name: "dosen-administrasi",
    component: () => import("../../views/dosen/administrasi/Administrasi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },

        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Administrasi", active: true },
      ],
      pageTitle: "Administrasi",
    },
  },
  {
    path: "/dosen/administrasi/penangguhan/:mahasiswaId",
    name: "dosen-administrasi-penangguhan",
    component: () => import("../../views/dosen/administrasi/Penangguhan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Administrasi", url: "/dosen/administrasi" },
        { title: "Penangguhan", active: true },
      ],
      pageTitle: "Penangguhan",
    },
  },

  /**
   *  KEHADIRAN
   */
  {
    path: "/dosen/kehadiran",
    name: "dosen-kehadiran",
    beforeEnter() {
      window.location.href = "https://pembelajaran.ubpkarawang.ac.id/";
    },
  },

  {
    path: "/dosen/bantuan-publikasi",
    name: "dosen-bantuan-publikasi",
    beforeEnter() {
      window.location.href = "https://ppi.ubpkarawang.ac.id/";
    },
  },
  /**
   *  KEHADIRAN
   */
  {
    path: "/dosen/sister",
    name: "dosen-sister",
    beforeEnter() {
      window.location.href = "http://101.255.64.196:8081/";
    },
  },
  {
    path: "/dosen/lpm",
    name: "dosen-lpm",
    beforeEnter() {
      window.location.href = "https://lpm.ubpkarawang.ac.id/app/auth";
    },
  },
  {
    path: "/dosen/ami",
    name: "dosen-ami",
    beforeEnter() {
      window.location.href = "https://ami.ubpkarawang.ac.id/login";
    },
  },

  /**
   *   TUGAS AKHIR
   */

  {
    path: "/dosen/tugas-akhir",
    name: "dosen-tugas-akhir",
    component: () =>
      import("../../views/dosen/tugas-akhir/DaftarMahasiswaBimbingan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },

        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Tugas Akhir", active: true },
      ],
      pageTitle: "Tugas Akhir",
    },
  },

  /**
   *  TURNITIN MAHASISWA
   */
  {
    path: "/dosen/turnitin-mahasiswa",
    name: "dosen-turnitin-mahasiswa",
    component: () =>
      import("../../views/dosen/turnitin-mahasiswa/TurnitinMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },

        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Turnitin Mahasiswa", active: true },
      ],
      pageTitle: "Turnitin Mahasiswa",
    },
  },

  /**
   *  KURIKULUM
   */
  {
    path: "/dosen/kurikulum",
    name: "dosen-kurikulum",
    component: () => import("../../views/dosen/kurikulum/Kurikulum.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Kurikulum", active: true },
      ],
      pageTitle: "Kurikulum",
    },
  },

  {
    path: "/dosen/kurikulum/lihat-matakuliah/:kurikulumId",
    name: "dosen-kurikulum-matkul",
    component: () =>
      import("../../views/dosen/kurikulum/DetailMataKuliahKurikulum.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Kurikulum", url: "/dosen/kurikulum" },
        { title: "Detail Mata Kuliah", active: true },
      ],
      pageTitle: "Detail Mata Kuliah",
    },
  },

  /**
   *  SLIP GAJI
   */
  {
    path: "/dosen/slip-gaji",
    name: "dosen-slip-gaji",
    component: () => import("../../views/dosen/slip-gaji/SlipGaji.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Slip Gaji", active: true },
      ],
      pageTitle: "Slip Gaji",
    },
  },
  /**
   *  PUBLIKASI
   */
  {
    path: "/dosen/publikasi",
    name: "dosen-publikasi",
    component: () => import("../../views/dosen/publikasi/Publikasi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Publikasi", active: true },
      ],
      pageTitle: "Publikasi",
    },
  },
  /**
   *  PENELITIAN
   */
  {
    path: "/dosen/penelitian",
    name: "dosen-penelitian",
    component: () => import("../../views/dosen/penelitian/Penelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", active: true },
      ],
      pageTitle: "Penelitian",
    },
  },
  {
    path: "/dosen/penelitian/usulan-penelitian",
    name: "dosen-usulan-penelitian",
    component: () =>
      import("../../views/dosen/penelitian/UsulanPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        { title: "Usulan Penelitian", active: true },
      ],
      pageTitle: "Usulan Penelitian",
    },
  },
  {
    path: "/dosen/penelitian/catatan-penelitian",
    name: "dosen-catatan-penelitian",
    component: () =>
      import("../../views/dosen/penelitian/CatatanPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        { title: "Riwayat Usulan Penelitian", active: true },
      ],
      pageTitle: "Riwayat Usulan Penelitian",
    },
  },
  {
    path: "/dosen/penelitian/catatan-penelitian/:penelitianId",
    name: "dosen-catatan-penelitian-detail",
    component: () =>
      import("../../views/dosen/penelitian/DetailPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        {
          title: "Riwayat Usulan Penelitian",
          url: "/dosen/penelitian/catatan-penelitian",
        },
        { title: "Detail Usulan Penelitian", active: true },
      ],
      pageTitle: "Detail Usulan Penelitian",
    },
  },
  {
    path: "/dosen/pengabdian/sunting-usulan-pengabdian/:pengabdianId",
    name: "dosen-sunting-usulan-pengabdian",
    component: () =>
      import("../../views/dosen/pengabdian/SuntingUsulanPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Pengabdian", url: "/dosen/pengabdian" },
        {
          title: "Riwayat Usulan Pengabdian",
          url: "/dosen/pengabdian/catatan-pengabdian",
        },
        { title: "Sunting Usulan Pengabdian", active: true },
      ],
      pageTitle: "Sunting Usulan Pengabdian",
    },
  },
  {
    path: "/dosen/penelitian/sunting-usulan/:penelitianId",
    name: "dosen-sunting-usulan-penelitian",
    component: () =>
      import("../../views/dosen/penelitian/SuntingUsulanPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        {
          title: "Riwayat Usulan Penelitian",
          url: "/dosen/penelitian/catatan-penelitian",
        },
        { title: "Sunting Usulan Penelitian", active: true },
      ],
      pageTitle: "Sunting Usulan Penelitian",
    },
  },

  {
    path: "/dosen/penelitian/kuisioner-penelitian/:idPenelitian",
    name: "dosen-kuisioner-penelitian",
    component: () =>
      import("../../views/dosen/penelitian/KuisionerPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },

        { title: "Kuisioner Penelitian", active: true },
      ],
      pageTitle: "Kuisioner Penelitian",
    },
  },
  {
    path: "/dosen/penelitian/dosen-laporan-penelitian",
    name: "dosen-laporan-penelitian",
    component: () =>
      import("../../views/dosen/penelitian/laporanPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },

        { title: "laporan Penelitian", active: true },
      ],
      pageTitle: "laporan Penelitian",
    },
  },
  {
    path: "/dosen/penelitian/dosen-laporan-penelitian/add/:idPenelitian",
    name: "dosen-laporan-penelitian-add",
    component: () =>
      import("../../views/dosen/penelitian/laporanPenelitianAdd.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        {
          title: "laporan Penelitian",
          url: "/dosen/penelitian/dosen-laporan-penelitian",
        },
        { title: "Tambah laporan Penelitian", active: true },
      ],
      pageTitle: "Tambah laporan Penelitian",
    },
  },
  {
    path: "/dosen/penelitian/dosen-laporan-penelitian/detail/:idLaporan",
    name: "dosen-laporan-penelitian-detail",
    component: () =>
      import("../../views/dosen/penelitian/laporanPenelitianDetail.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        {
          title: "laporan Penelitian",
          url: "/dosen/penelitian/dosen-laporan-penelitian",
        },
        { title: "Detail laporan Penelitian", active: true },
      ],
      pageTitle: "Detail laporan Penelitian",
    },
  },
  {
    path: "/dosen/penelitian/dosen-laporan-penelitian/perbaikan/:idLaporan",
    name: "dosen-laporan-penelitian-perbaikan",
    component: () =>
      import("../../views/dosen/penelitian/laporanPenelitianPerbaikan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        {
          title: "laporan Penelitian",
          url: "/dosen/penelitian/dosen-laporan-penelitian",
        },
        { title: "perbaikan laporan Penelitian", active: true },
      ],
      pageTitle: "perbaikan laporan Penelitian",
    },
  },
  {
    path: "/dosen/pengabdian/dosen-laporan-pengabdian/detail/:idLaporan",
    name: "dosen-laporan-pengabdian-detail",
    component: () =>
      import("../../views/dosen/pengabdian/LaporanPengabdianDetail.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/pengabdian" },
        {
          title: "laporan Penelitian",
          url: "/dosen/pengabdian/dosen-laporan-pengabdian",
        },
        { title: "Detail Laporan Pengabdian", active: true },
      ],
      pageTitle: "Detail Laporan Pengabdian",
    },
  },

  // progress Penelitian
  // {
  //   path: "/dosen/penelitian/dosen-laporan-penelitian",
  //   name: "dosen-laporan-penelitian",
  //   component: () =>
  //     import("../../views/dosen/penelitian/laporanPenelitian.vue"),
  //   meta: {
  //     breadcrumb: [
  //       { title: "Home", url: "/apps" },
  //       { title: "Dosen", url: "/submenu/dosen" },
  //       { title: "Penelitian", url: "/dosen/penelitian" },
  //       {
  //         title: "Laporan Penelitian",
  //         url: "/dosen/penelitian/dosen-laporan-penelitian",
  //       },
  //       { title: "Laporan Penelitian", active: true },
  //     ],
  //     pageTitle: "Laporan Penelitian",
  //   },
  // },
  // {
  //   path: "/dosen/penelitian/dosen-laporan-penelitian/add",
  //   name: "dosen-laporan-penelitian-add",
  //   component: () =>
  //     import("../../views/dosen/penelitian/laporanPenelitianAdd.vue"),
  //   meta: {
  //     breadcrumb: [
  //       { title: "Home", url: "/apps" },
  //       { title: "Dosen", url: "/submenu/dosen" },
  //       { title: "Penelitian", url: "/dosen/penelitian" },
  //       {
  //         title: "Laporan Penelitian",
  //         url: "/dosen/penelitian/dosen-laporan-penelitian",
  //       },
  //       {
  //         title: "Tambah Laporan Penelitian",
  //         active: true,
  //       },
  //     ],
  //     pageTitle: "Tambah Laporan Penelitian",
  //   },
  // },
  {
    path: "/dosen/penelitian/dosen-progress-penelitian",
    name: "dosen-progress-penelitian",
    component: () =>
      import("../../views/dosen/penelitian/ProgressPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        { title: "Progress Penelitian", active: true },
      ],
      pageTitle: "Progress Penelitian",
    },
  },
  {
    path: "/dosen/penelitian/dosen-progress-penelitian-list/:idPenelitian",
    name: "progress-penelitian-list",
    component: () =>
      import("../../views/dosen/penelitian/ProgressPenelitianList.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        {
          title: "Progress-penelitian",
          url: "/dosen/penelitian/dosen-progress-penelitian",
        },
        { title: "Progress Penelitian List", active: true },
      ],
      pageTitle: "Progress Penelitian List",
    },
  },
  {
    path: "/dosen/penelitian/dosen-progress-penelitian-detail/:idProgress",
    name: "progress-penelitian-detail",
    component: () =>
      import("../../views/dosen/penelitian/ProgressPenelitianDetail.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        {
          title: "Progress Penelitian",
          url: "/dosen/penelitian/dosen-progress-penelitian",
        },
        { title: "Progress Penelitian Detail", active: true },
      ],
      pageTitle: "Progress Penelitian Detail",
    },
  },
  {
    path: "/dosen/penelitian/dosen-progress-penelitian-add/:idPenelitian",
    name: "progress-penelitian-add",
    component: () =>
      import("../../views/dosen/penelitian/ProgressPenelitianAdd.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        {
          title: "Progress Penelitian",
          url: "/dosen/penelitian/dosen-progress-penelitian",
        },
        { title: "Progress Penelitian Add", active: true },
      ],
      pageTitle: "Progress Penelitian Add",
    },
  },
  {
    path: "/dosen/penelitian/dosen-progress-penelitian-edit/:idPenelitian/:idProgress",
    name: "progress-penelitian-edit",
    component: () =>
      import("../../views/dosen/penelitian/ProgressPenelitianEdit.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        {
          title: "Progress Penelitian",
          url: "/dosen/penelitian/dosen-progress-penelitian",
        },
        { title: "Progress Penelitian Edit", active: true },
      ],
      pageTitle: "Progress Penelitian Edit",
    },
  },
  {
    path: "/dosen/penelitian/anggota-pengusul/:penelitianId",
    name: "dosen-tambah-pengusul-penelitian",
    component: () =>
      import("../../views/dosen/penelitian/PengusulPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        {
          title: "Catatan Penelitian",
          url: "/dosen/penelitian/catatan-penelitian",
        },
        { title: "Pengusul Penelitian", active: true },
      ],
      pageTitle: "Pengusul Penelitian",
    },
  },
  //pengabdian update
  {
    path: "/dosen/pengabdian/anggota-pengusul/:pengabdianId",
    name: "dosen-tambah-pengusul-pengabdian",
    component: () =>
      import("../../views/dosen/pengabdian/PengusulPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Pengabdian", url: "/dosen/pengabdian" },
        {
          title: "Catatan Pengabdian",
          url: "/dosen/pengabdian/catatan-pengabdian",
        },
        { title: "Pengusul Pengabdian", active: true },
      ],
      pageTitle: "Pengusul Pengabdian",
    },
  },
  {
    path: "/dosen/penelitian/mitra-penelitian/:penelitianId",
    name: "dosen-tambah-mitra-penelitian",
    component: () => import("../../views/dosen/penelitian/MitraPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        {
          title: "Catatan Penelitian",
          url: "/dosen/penelitian/catatan-penelitian",
        },
        { title: "Mitra Penelitian", active: true },
      ],
      pageTitle: "Mitra Penelitian",
    },
  },
  {
    path: "/dosen/penelitian/luaran-penelitian/:penelitianId",
    name: "dosen-tambah-luaran-penelitian",
    component: () =>
      import("../../views/dosen/penelitian/LuaranPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        {
          title: "Catatan Penelitian",
          url: "/dosen/penelitian/catatan-penelitian",
        },
        { title: "Luaran Penelitian", active: true },
      ],
      pageTitle: "Luaran Penelitian",
    },
  },
  {
    path: "/dosen/penelitian/tugas-review",
    name: "dosen-tugas-review",
    component: () => import("../../views/dosen/penelitian/TugasReview.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        { title: "Tugas Review Proposal", active: true },
      ],
      pageTitle: "Tugas Review Proposal",
    },
  },
  {
    path: "/dosen/penelitian/tugas-review-laporan-penelitian",
    name: "dosen-tugas-review-laporan-penelitian",
    component: () =>
      import("../../views/dosen/penelitian/TugasReviewLaporanPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        { title: "Tugas Review Proposal", active: true },
      ],
      pageTitle: "Tugas Review Proposal",
    },
  },

  {
    path: "/dosen/penelitian/tugas-review-laporan-penelitian/show/:idLaporan",
    name: "dosen-tugas-review-laporan-penelitian-show",
    component: () =>
      import(
        "../../views/dosen/penelitian/TugasReviewLaporanPenelitianShow.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Penelitian", url: "/dosen/penelitian" },
        { title: "Tugas Review Proposal", active: true },
      ],
      pageTitle: "Tugas Review Proposal",
    },
  },
  /**
   *  PENGABDIAN
   */
  {
    path: "/dosen/pengabdian",
    name: "dosen-pengabdian",
    component: () => import("../../views/dosen/pengabdian/Penelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Pengabdian", active: true },
      ],
      pageTitle: "Pengabdian",
    },
  },
  {
    path: "/dosen/pengabdian/usulan-pengabdian",
    name: "dosen-usulan-pengabdian",
    component: () =>
      import("../../views/dosen/pengabdian/UsulanPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Pengabdian", url: "/dosen/pengabdian" },
        { title: "Usulan Pengabdian", active: true },
      ],
      pageTitle: "Usulan Pengabdian",
    },
  },
  {
    path: "/dosen/pengabdian/catatan-pengabdian",
    name: "dosen-catatan-pengabdian",
    component: () =>
      import("../../views/dosen/pengabdian/CatatanPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Pengabdian", url: "/dosen/pengabdian" },
        { title: "Catatan Pengabdian", active: true },
      ],
      pageTitle: "Catatan Pengabdian",
    },
  },
  {
    path: "/dosen/pengabdian/catatan-pengabdian/:pengabdianId",
    name: "dosen-catatan-pengabdian-detail",
    component: () =>
      import("../../views/dosen/pengabdian/DetailPengabdian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Pengabdian", url: "/dosen/pengabdian" },
        {
          title: "Catatan Pengabdian",
          url: "/dosen/pengabdian/catatan-pengabdian",
        },
        { title: "Riwayat Usulan Pengabdian", active: true },
      ],
      pageTitle: "Riwayat Usulan Pengabdian",
    },
  },

  {
    path: "/dosen/pengabdian/kuisioner-pengabdian/:idPengabdian",
    name: "dosen-kuisioner-pengabdian",
    component: () =>
      import("../../views/dosen/pengabdian/KuisionerPengabdian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "pengabdian", url: "/dosen/pengabdian" },

        { title: "Kuisioner pengabdian", active: true },
      ],
      pageTitle: "Kuisioner pengabdian",
    },
  },

  {
    path: "/dosen/pengabdian/mitra-pengabdian/:pengabdianId",
    name: "dosen-tambah-mitra-pengabdian",
    component: () => import("../../views/dosen/pengabdian/MitraPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Pengabdian", url: "/dosen/pengabdian" },
        {
          title: "Catatan Pengabdian",
          url: "/dosen/pengabdian/catatan-pengabdian",
        },
        { title: "Mitra Pengabdian", active: true },
      ],
      pageTitle: "Mitra Pengabdian",
    },
  },
  {
    path: "/dosen/pengabdian/luaran-pengabdian/:pengabdianId",
    name: "dosen-tambah-luaran-pengabdian",
    component: () =>
      import("../../views/dosen/pengabdian/LuaranPenelitian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "Pengabdian", url: "/dosen/pengabdian" },
        {
          title: "Catatan Pengabdian",
          url: "/dosen/pengabdian/catatan-pengabdian",
        },
        { title: "Luaran Pengabdian", active: true },
      ],
      pageTitle: "Luaran Pengabdian",
    },
  },
  {
    path: "/dosen/pengabdian/tugas-review",
    name: "dosen-tugas-review-pengabdian",
    component: () => import("../../views/dosen/pengabdian/TugasReview.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "pengabdian", url: "/dosen/pengabdian" },
        { title: "Tugas Review Proposal", active: true },
      ],
      pageTitle: "Tugas Review Proposal",
    },
  },

  {
    path: "/dosen/pengabdian/dosen-progress-pengabdian",
    name: "dosen-progress-pengabdian",
    component: () =>
      import("../../views/dosen/pengabdian/Progresspengabdian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "pengabdian", url: "/dosen/pengabdian" },
        { title: "Progress pengabdian", active: true },
      ],
      pageTitle: "Progress pengabdian",
    },
  },

  {
    path: "/dosen/pengabdian/dosen-progress-pengabdian-add/:idpengabdian",
    name: "progress-pengabdian-add",
    component: () =>
      import("../../views/dosen/pengabdian/ProgresspengabdianAdd.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "pengabdian", url: "/dosen/pengabdian" },
        {
          title: "Progress pengabdian",
          url: "/dosen/pengabdian/dosen-progress-pengabdian",
        },
        { title: "Progress pengabdian Add", active: true },
      ],
      pageTitle: "Progress pengabdian Add",
    },
  },

  {
    path: "/dosen/pengabdian/dosen-laporan-pengabdian",
    name: "dosen-laporan-pengabdian",
    component: () =>
      import("../../views/dosen/pengabdian/laporanpengabdian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "pengabdian", url: "/dosen/pengabdian" },

        { title: "laporan pengabdian", active: true },
      ],
      pageTitle: "laporan pengabdian",
    },
  },
  {
    path: "/dosen/pengabdian/dosen-laporan-pengabdian/add/:idPengabdian",
    name: "dosen-laporan-pengabdian-add",
    component: () =>
      import("../../views/dosen/pengabdian/laporanpengabdianAdd.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dosen", url: "/submenu/dosen" },
        { title: "pengabdian", url: "/dosen/pengabdian" },
        {
          title: "laporan pengabdian",
          url: "/dosen/pengabdian/dosen-laporan-pengabdian",
        },
        { title: "Tambah laporan pengabdian", active: true },
      ],
      pageTitle: "Tamba laporan pengabdian",
    },
  },
];
